import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
// import cookie from 'react-cookies';

//components
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";

// modals
import ConfirmAlert from "../../modal/ConfirmAlert/ConfirmAlert";

// services
import AuthService from "../../services/AuthService";
import Validation from "../../services/Validation";
import Storage from "../../services/Storage";
import UserService from "../../services/UserService";
// import ModalService from '../../services/ModalService';

// actions
import { setUserDetail } from "../../actions/UserAction";

// constant
import { messages } from "../../constants/constant.message";

// css
import "./Login.css";
import { Roles } from "../../constants/constant.role";

const { EMPTY_PASSWORD, EMPTY_USER_NAME } = messages.LOGIN;

class Login extends Component {
  state = {
    height: window.innerHeight,
    width: window.innerWidth,
    redirectToOnBoarding: false,
    redirectToDashBoard: false,
    redirectToForgotPasswordPage: false,
    errResponseMessage: "",
    isLoading: false,
    controls: {
      username: {
        value: "",
        valid: null,
        touched: false,
        nullValue: null,
      },
      password: {
        value: "",
        valid: null,
        touched: false,
        nullValue: null,
        invalidPassword: null,
      },
      keepMeLoggenIn: false,
    },
    isFormValid: false,
    isErrorModalOpen: false,
    errorMessage: "Something went wrong",
  };

  componentDidMount() {
    window.addEventListener("resize", this.resizeWindow);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeWindow);
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    controls[controlName].value = controlValue;
    controls[controlName].touched = true;
    this.setState({ controls });
    // this.handleValidation();
  };

  setCheckBoxValue = () => {
    const { controls } = this.state;
    controls.keepMeLoggenIn = !controls.keepMeLoggenIn;
    this.setState({ controls });
  };

  login = (e) => {
    e.preventDefault();
    const { controls } = this.state;
    const { username, password, keepMeLoggenIn } = controls;

    const isFormValid = this.handleValidation();

    if (isFormValid === false) {
      return;
    }

    const obj = {
      username: username.value,
      password: password.value,
    };
    this.setState({ errResponseMessage: "", isLoading: true });
    AuthService.login(obj)
      .then((data) => {
        const response = data.data;

        const obj = {
          accessToken: response.accessToken,
          accessTokenExpiresAt: response.accessTokenExpiresAt,
          refreshToken: response.refreshToken,
          refreshTokenExpiresAt: response.refreshTokenExpiresAt,
        };
        const userDetail = response.user;
        Storage.setTokenDetail(obj);
        Storage.setUserDetail(userDetail);
        Storage.setIsTermConditionModal(true);
        if (keepMeLoggenIn === true) {
          this.setKeepMeLoggedIn(true);
        } else {
          this.setKeepMeLoggedIn(false);
        }

        if (userDetail.is_login_first_time === true) {
          this.setState({ redirectToOnBoarding: true, isLoading: false });
        } else {
          this.setState({ redirectToDashBoard: true, isLoading: false });
        }
        // this.getUserDetail();
      })
      .catch((e) => {
        console.log("e", e.response);
        let err =
          e.response && e.response.data && e.response.data.error[0]
            ? e.response.data.error[0]
            : null;
        const message =
          err && err.message ? err.message : "Something went wrong";

        // ModalService.openAlert('Login', message, 'error');
        this.setState({
          errResponseMessage: message,
          isLoading: false,
          //  errorMessage: message, isErrorModalOpen: true
        });
      });
  };

  getUserDetail = () => {
    UserService.getUserInfo()
      .then((data) => {
        const userData = data.data.data;
        this.props.setUserDetail(userData);

        let role = userData.type;
        if (role === Roles.FLEET_MANAGER_ROLE) {
          this.setState({ redirectToDashBoard: true });
        } else {
          if (userData.is_login_first_time === true) {
            this.setState({ redirectToOnBoarding: true });
          } else {
            this.setState({ redirectToDashBoard: true });
          }
        }
      })
      .catch((e) => {
        console.error("e", e);
      });
  };

  // forgotPassword = () => {
  //   AuthService.forgotPassword()
  // }

  handleValidation = () => {
    let { controls, isFormValid } = this.state;
    let { username, password } = controls;

    username = Validation.notNullValidator(username);
    username.valid = !username.nullValue;

    password = Validation.notNullValidator(password);
    password.valid = !password.nullValue;

    if (username.valid === true && password.valid === true) {
      isFormValid = true;
    } else {
      isFormValid = false;
    }
    this.setState({ controls, isFormValid });

    return isFormValid;
  };

  resizeWindow = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  openForgotPasswordPage = () => {
    this.setState({ redirectToForgotPasswordPage: true });
  };

  openErrorModal = () => {
    this.setState({ isErrorModalOpen: true });
  };

  closeErrorModal = () => {
    this.setState({ isErrorModalOpen: false });
  };

  setKeepMeLoggedIn = (value) => {
    Storage.setKeepMeLoggedInCookie(value);
  };

  openInvitedFleet = () => {
    this.props.history.push("/invited-fleet");
  };

  render() {
    const {
      controls,
      redirectToOnBoarding,
      redirectToDashBoard,
      redirectToForgotPasswordPage,
      errResponseMessage,
    } = this.state;
    const { username, password, keepMeLoggenIn } = controls;
    return (
      <div id="login">
        {/* <Container> */}
        {this.state.isLoading && <CustomSpinner></CustomSpinner>}
        {/* {true && <CustomSpinner></CustomSpinner>} */}
        {redirectToOnBoarding && <Redirect to="/on-boarding" />}
        {redirectToDashBoard && <Redirect to="/dashboard" />}
        {redirectToForgotPasswordPage && <Redirect to="/forgot-password" />}
        <ConfirmAlert
          closeModal={this.closeErrorModal}
          // open={this.state.isErrorModalOpen}
          title="Login"
          error={true}
          msg={this.state.errorMessage}
          show={this.state.isErrorModalOpen}
        ></ConfirmAlert>
        {/* <ErrorModal
          closeModal={this.closeErrorModal}
          // open={this.state.isErrorModalOpen}
          title="Login"
          msg={this.state.errorMessage}
          open={this.state.isErrorModalOpen}
        /> */}
        <Row>
          <Col
            xl="3"
            xs="1"
            md="1"
            className={this.state.width < 1200 ? "display-none" : ""}
          >
            <img className="login-left-img" src="images/login-img.jpg" alt="" />
          </Col>
          <Col xl="1" xs="1" md="1" />
          <Col xl="7" xs="10" md="10" className="login-container">
            <Form className="width-100">
              <Row
                className={this.state.width < 1200 ? "margin-top-20" : null}
              />
              <Row className="padding-left-13" style={{ marginBottom: "20px" }}>
                <img
                  src="images/logo.png"
                  alt=""
                  width="128px"
                  height="94px"
                  style={{ objectFit: "contain" }}
                />
              </Row>
              <Row className="welcome-text">Welcome</Row>
              <Row className="sign-in-subtitle-text margin-top-5">
                <div>Please sign in to your account</div>
              </Row>
              <hr />
              <div>
                {/* <div><Spinner /></div> */}
                <Row>
                  <Col xl="6" xs="12" md="12">
                    {/* <Row> */}
                    <FormGroup>
                      <Label for="username">User ID</Label>
                      <Input
                        type="text"
                        name="username"
                        id="username"
                        className="login-input"
                        value={username.value}
                        onChange={this.handleInputChange}
                      />
                      <div className="error-container">
                        {username.nullValue && (
                          <div className="error">* {EMPTY_USER_NAME}</div>
                        )}
                        {!(
                          errResponseMessage === null ||
                          errResponseMessage === ""
                        ) && <div className="error">{errResponseMessage}</div>}
                      </div>
                    </FormGroup>
                    {/* </Row> */}
                  </Col>
                  <Col xl="6" xs="12" md="12">
                    {/* <Row> */}
                    <FormGroup>
                      <Label for="password">Password</Label>
                      <Input
                        type="password"
                        name="password"
                        id="password"
                        className="login-input"
                        value={password.value}
                        onChange={this.handleInputChange}
                      />
                      <div className="error-container">
                        {password.nullValue && (
                          <div className="error">* {EMPTY_PASSWORD}</div>
                        )}
                      </div>
                    </FormGroup>
                    {/* </Row> */}
                  </Col>
                </Row>
                <Row className="padding-left-13">
                  <label class="container-cb">
                    <input
                      type="checkbox"
                      name="checkbox"
                      id="checkbox"
                      checked={keepMeLoggenIn}
                      onChange={this.setCheckBoxValue}
                    />{" "}
                    Keep me logged in
                    <span class="checkmark"></span>
                  </label>
                  {/* <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        name="checkbox"
                        id="checkbox"
                        checked={keepMeLoggenIn}
                        onChange={this.setCheckBoxValue}
                      />{' '}
                      Keep me logged in
                    </Label>
                  </FormGroup> */}
                </Row>
                <hr />
                <Row>
                  <Col
                    xl="4"
                    className={this.state.width < 1200 ? "display-none" : ""}
                  />
                  <Col xl="12" xs="12" md="12" className="text-align-right">
                    {/* <Button className="mb-1 mr-1 btn-pill action-button forgot-password"
                      color="dark"
                      onClick={() => { this.openInvitedFleet() }}
                    >
                      Invited Fleet
                    </Button>{'  '} */}
                    <Button
                      className="mb-1 mr-1 btn-pill action-button forgot-password"
                      color="dark"
                      onClick={this.openForgotPasswordPage}
                    >
                      Recover Password
                    </Button>
                    {"  "}
                    <Button
                      className="mb-1 mr-1 btn-pill action-button login-button"
                      color="warning"
                      onClick={this.login}
                      type="submit"
                    >
                      Login
                    </Button>
                  </Col>
                </Row>
              </div>
            </Form>
          </Col>
          <Col xl="1" xs="1" sm="1" />
        </Row>
        {/* </Container> */}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setUserDetail: (user) => dispatch(setUserDetail(user)),
});

export default connect(
  null,
  mapDispatchToProps
)(Login);
